import axios from 'axios';
import { DASHBOARD_API_URL } from '@/lib/constants/login';
import { camelify } from '@/helpers/case';

/* istanbul ignore next */
export function axiosInstance(ciToken = '') {
  return axios.create({
    baseURL: DASHBOARD_API_URL,
    headers: {
      'Authorization': `Token ${ciToken}`,
    },
  });
}

// Create a Plan Sponsor
export function planSponsorsGetListCtor(_) {
  return async () => {
    /* istanbul ignore next */
    if(!_.axiosInstance) {
      const store = await import('@/store');
      _.axiosInstance = axiosInstance(store.getters.ciToken);
    }
    const _axios = _.axiosInstance;
    try {
      const result = await _axios.get('/api/advisor/plan_sponsors');
      return camelify(result.data);
    } catch(e) {
      return Promise.reject(e);
    }
  };
}

export const planSponsorsGetList = planSponsorsGetListCtor({ axiosInstance: null });